export default __webpack_public_path__ + "static/BetterTool_logos-852c310d90fad4412ee6cd0f3c2cd774.svg";